var staticStrFirst = 'first'

module.exports = staticStrFirst
